<template>
  <v-card class="mb-4">
    <v-card-title>
      <v-btn
        flat
        @click="mostrarFiltros = !mostrarFiltros"
        style="width: 100%; justify-content: flex-start;"
      >
        <v-icon left>filter_list</v-icon>
        Filtros
        <v-spacer></v-spacer>
        <v-icon>{{ mostrarFiltros ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
    </v-card-title>
    
    <v-slide-y-transition>
      <v-card-text v-show="mostrarFiltros">
        <v-layout row wrap>
          <v-flex xs12 sm6 md3>
            <v-select
              v-model="filtrosLocal.estado"
              :items="estados"
              item-text="text"
              item-value="value"
              label="Estado"
              clearable
              @change="emitirCambios"
            />
          </v-flex>
          
          <v-flex xs12 sm6 md3>
            <v-text-field
              v-model="filtrosLocal.busqueda"
              label="Buscar participante..."
              prepend-icon="search"
              clearable
              @input="debounceEmitir"
            />
          </v-flex>
          
          <v-flex xs12 sm6 md3>
            <v-menu
              v-model="menuFechaDesde"
              :close-on-content-click="false"
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fechaDesdeFormateada"
                label="Fecha desde"
                prepend-icon="event"
                readonly
              />
              <v-date-picker
                v-model="filtrosLocal.fechaDesde"
                @input="menuFechaDesde = false; emitirCambios()"
              />
            </v-menu>
          </v-flex>
          
          <v-flex xs12 sm6 md3>
            <v-menu
              v-model="menuFechaHasta"
              :close-on-content-click="false"
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fechaHastaFormateada"
                label="Fecha hasta"
                prepend-icon="event"
                readonly
              />
              <v-date-picker
                v-model="filtrosLocal.fechaHasta"
                @input="menuFechaHasta = false; emitirCambios()"
              />
            </v-menu>
          </v-flex>
        </v-layout>
        
        <v-layout row>
          <v-flex xs12>
            <v-btn color="secondary" @click="limpiarFiltros">
              <v-icon left>clear</v-icon>
              Limpiar Filtros
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'PagosFiltros',
  props: {
    estados: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mostrarFiltros: false,
      menuFechaDesde: false,
      menuFechaHasta: false,
      filtrosLocal: {
        estado: '',
        fechaDesde: null,
        fechaHasta: null,
        busqueda: ''
      }
    };
  },
  computed: {
    fechaDesdeFormateada() {
      return this.filtrosLocal.fechaDesde ? 
        this.$moment(this.filtrosLocal.fechaDesde).format('DD/MM/YYYY') : '';
    },
    fechaHastaFormateada() {
      return this.filtrosLocal.fechaHasta ? 
        this.$moment(this.filtrosLocal.fechaHasta).format('DD/MM/YYYY') : '';
    }
  },
  methods: {
    emitirCambios() {
      this.$emit('filtrosChanged', this.filtrosLocal);
    },
    
    debounceEmitir: debounce(function() {
      this.emitirCambios();
    }, 500),
    
    limpiarFiltros() {
      this.filtrosLocal = {
        estado: '',
        fechaDesde: null,
        fechaHasta: null,
        busqueda: ''
      };
      this.emitirCambios();
    }
  }
};
</script>